import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Modal from '../Modal';

class ChooseDate extends React.Component {
  state = {
    startDate: this.props.startDate,
    endDate: this.props.endDate
  };

  render() {
    const { visible, onClose } = this.props;

    const selectionRange = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      key: 'selection'
    };

    var that = this;

    var startDate = $('#startDate').data('kendoDatePicker');
    var endDate = $('#endDate').data('kendoDatePicker');

    $('#startDate').kendoDatePicker({
      value: moment(this.state.startDate).format(),

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          startDate: value
        });
      }
    });

    $('#endDate').kendoDatePicker({
      value: moment(this.state.endDate).format(),

      change: function(e) {
        var value = e.sender.value();

        that.setState({
          endDate: value
        });
      }
    });

    return (
      <Modal title="Export" visible={visible} onClose={onClose}>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <label>Start Date *</label>
            <br />
            <input
              id="startDate"
              placeholder="dd/mm/yyyy"
              className="full-width"
            />
          </div>
          <div className="col-xs-12 col-md-6">
            <label>End Date *</label>
            <br />
            <input
              id="endDate"
              placeholder="dd/mm/yyyy"
              className="full-width"
            />
          </div>
        </div>
        <hr />
        <div>
          {this.state.startDate &&
          this.state.endDate &&
          (moment(this.state.startDate).isBefore(this.state.endDate, 'day') ||
            moment(this.state.startDate).isSame(this.state.endDate, 'day')) ? (
            <a
              className="btn btn-pink btn-block btn-raised"
              onClick={this.handlerSubmit}
              onKeyDown={(e) => e.key === "Enter" && this.handlerSubmit()}
              tabIndex={0}
            >
              EXPORT
            </a>
          ) : (
            <a className="btn btn-pink btn-block btn-raised disabled">EXPORT</a>
          )}
        </div>
      </Modal>
    );
  }

  handleSelect = ranges => {
    this.setState({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });
  };

  handlerSubmit = () => {
    this.props.onExport(
      moment(this.state.startDate).format('Y-MM-DD'),
      moment(this.state.endDate).format('Y-MM-DD')
    );
  };
}

ChooseDate.propTypes = {
  visible: PropTypes.bool,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired
};

ChooseDate.defaultProps = {
  startDate: moment()
    .day(0)
    .format(),
  endDate: moment()
    .day(6)
    .format()
};

export default ChooseDate;
